<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：我提交了作业，但老师说没收到！</p>
      <p>答：请您查看首页是否显示【我的作业】卡片，如有此卡片表信息表示当前还有作业未完成。已完成的作业可在【我的】—【我的作业】—【已完成作业】中查看。</p>
    </div>
    <div class="ha-img">
      <img src="./img/unget-task1.png" alt="">
    </div>
    <div class="ha-des">
       <p>如果您确定已经提交了全部的作业，“已完成作业”中是空的，那么您一定是不小心有两个账号都加入了班级，老师那边看到未完成作业的是另外一个账号。您登录那个不需要的账号后，APP中点击班级，右上角退出班级即可。</p>
    </div>
    <div class="ha-img-02">
      <img src="./img/unget-task2.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
    .ha-img-02 {
      img {
        width: 90%;
      }
      padding-right: p2r(30);
      text-align: right;
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = "其他问题? 可瀚学堂-深圳市格熙信息科技有限公司"
      this.$sendAnalytics('点击我提交了作业，但老师说没收到')
    },
    components: {}
  }
</script>
